import {
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  SimpleGrid,
  HStack,
  Button,
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../../components/shared/CommonContainer";
import ConnectWallet from "../../components/freelancer/earnings/ConnectWallet";
import Show from "../../components/freelancer/earnings/Show";

export default function FreelancerEarningsPage() {
  return (
    <CommonContainer>
      <Stack my={20}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "26px" }}
          pb={10}
        >
          Earnings
        </Heading>
        <SimpleGrid columns={5} display={{ base: "none", xl: "grid" }}>
          {earningsHeader.map((item, index) => {
            return (
              <Box
                border="1px solid #c5c5c5"
                borderColor="#c5c5c5"
                borderRight={index === 4 ? "1px solid #c5c5c5" : 0}
                key={index}
              >
                <Text
                  bg="#f4f4f4"
                  py={4}
                  textAlign="center"
                  fontSize={{ base: "16px", "2xl": "20px" }}
                  fontWeight="medium"
                >
                  {item}
                </Text>
                <Text
                  py={6}
                  textAlign="center"
                  fontSize={{ base: "16px", "2xl": "20px" }}
                  fontWeight="medium"
                  borderTop="1px"
                  borderColor="#c5c5c5"
                >
                  0
                </Text>
              </Box>
            );
          })}
        </SimpleGrid>
        <Stack
          rounded="lg"
          spacing={0}
          border="2px solid #c5c5c5"
          display={{ base: "flex", xl: "none" }}
        >
          {earningsHeader.map((item, index) => {
            return (
              <HStack
                key={item}
                spacing={0}
                fontSize={{ base: "14px", md: "16px" }}
                height="full"
              >
                <Box
                  w={{ base: "70%", md: "50%" }}
                  p={2}
                  bg="#f4f4f4"
                  borderColor="#c5c5c5"
                  height="full"
                  borderRight="1px"
                  borderBottom={earningsHeader.length - 1 !== index && "1px"}
                >
                  {item}
                </Box>
                <Box
                  w={{ base: "30%", md: "50%" }}
                  borderColor="#c5c5c5"
                  p={2}
                  borderBottom={earningsHeader.length - 1 !== index && "1px"}
                  textAlign="center"
                >
                  0
                </Box>
              </HStack>
            );
          })}
        </Stack>
        <HStack justifyContent="end" py={10}>
          <Button
            bg="brand.500"
            borderRadius={10}
            color="white"
            px={10}
            py={6}
            _hover={{ bg: "brand.400", color: "white" }}
          >
            Get Statement Of Earnings
          </Button>
        </HStack>
        <Flex gap={8} flexDir={{ base: "column", xl: "row" }}>
          <Box w={{ xl: "45%" }}>
            <ConnectWallet />
          </Box>
          <Box w={{ xl: "55%" }}>
            <Show />
          </Box>
        </Flex>
      </Stack>
    </CommonContainer>
  );
}
const earningsHeader = [
  "Net Income",
  "Withdrawls",
  "Used For Purchases",
  "Pending Clearance",
  "Available For Withdrawal",
];
